const a = "_avatarLabelContainer_1wkmk_1", t = "_actionable_1wkmk_8", e = {
  avatarLabelContainer: a,
  actionable: t
};
export {
  t as actionable,
  a as avatarLabelContainer,
  e as default
};
//# sourceMappingURL=AvatarLabel.module.scss.js.map
